import type { SetupFieldSlideProps } from "@/types/setup/flow";

export const SetupFieldSlide = ({ question, error, registerProps, flat = false }: SetupFieldSlideProps) => {
  const Icon = question.icon;

  return (
    <div
      className={
        flat
          ? "w-full"
          : "w-full rounded-[20px] border border-genie-border bg-white p-4 md:p-5 shadow-lg shadow-genie-primary/10"
      }
    >
      <label htmlFor={question.id} className="text-[12.5px] font-semibold text-gray-700">
        {question.label}
      </label>
      <div
        className={`mt-2 h-[56px] rounded-2xl border bg-genie-background/70 px-4 flex items-center gap-3 transition-colors focus-within:ring-2 focus-within:ring-genie-primary/30 focus-within:border-genie-primary ${
          error ? "border-genie-secondary" : "border-genie-border"
        }`}
      >
        <Icon className="h-5 w-5 text-gray-500 flex-shrink-0" strokeWidth={1.8} />
        <input
          id={question.id}
          type="text"
          inputMode={question.inputMode}
          autoComplete={question.autoComplete}
          placeholder={question.placeholder}
          className="min-w-0 flex-1 bg-transparent text-base font-semibold text-[#222B45] outline-none placeholder:text-gray-400 placeholder:font-normal"
          {...registerProps}
        />
      </div>
      {error ? (
        <p className="mt-2 text-xs font-medium text-genie-secondary">{error}</p>
      ) : (
        <div className="mt-3 flex items-start gap-2">
          <span className="mt-1 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8]" />
          <p className="text-xs text-gray-500">{question.hint}</p>
        </div>
      )}
    </div>
  );
};
